import { connect } from 'react-redux'
import requestChangeCardParent from '../../../sagas/requestChangeCardParent'
import requestAddNewChildCard from '../../../sagas/requestAddNewChildCard'
import addSubCardSelector from './addSubCardSelector'
import AddSubCard from './AddSubCard'
import { withBoardContext } from 'dataProviders/Board'

export default withBoardContext(connect(
  addSubCardSelector,
  {
    requestChangeCardParent,
    requestAddNewChildCard
  }
)(AddSubCard))
